import { Logger } from '@vue-storefront/core';
import { NATIVE_ROUTE } from '~/constants/routes';
import { hasNativeRouteRedirection } from '~/helpers/navigation/nativeRoutingRedirection';
import { SEO_REDIRECTION_CODE } from '~/constants/seo';

const redirectToCorrectPath = ({
  oldPrefix, redirect, path, query, isNativeRoutingEnabled,
}) => {
  Logger.warn(`Old url structure ${oldPrefix} is still being used.`);
  const replaceValue = isNativeRoutingEnabled ? `/${NATIVE_ROUTE.CATEGORY}/` : '/';
  redirect(SEO_REDIRECTION_CODE, path.replace(oldPrefix, replaceValue), query);
};

export default ({ app: { context: { route, i18n } }, redirect }) => {
  const { query, path } = route;
  const oldPrefixForCategoryCmsPage = '/category/';
  const oldPrefixForCategorySearchPage = '/search/';
  const newPrefixForCategoryPage = `/${NATIVE_ROUTE.CATEGORY}/`;
  const newPrefixForPdp = `/${NATIVE_ROUTE.PRODUCT}/`;
  const countryCode = i18n.localeProperties.country;
  const isNativeRoutingEnabled = hasNativeRouteRedirection(countryCode);
  if (!isNativeRoutingEnabled && path.includes(newPrefixForCategoryPage)) {
    redirectToCorrectPath({
      oldPrefix: newPrefixForCategoryPage,
      redirect,
      path,
      query,
    });
  } else if (!isNativeRoutingEnabled && path.includes(newPrefixForPdp)) {
    redirectToCorrectPath({
      oldPrefix: newPrefixForPdp,
      redirect,
      path,
      query,
    });
  } else if (path.includes(oldPrefixForCategoryCmsPage)) {
    redirectToCorrectPath({
      oldPrefix: oldPrefixForCategoryCmsPage,
      redirect,
      path,
      query,
      isNativeRoutingEnabled,
    });
  } else if (path.includes(oldPrefixForCategorySearchPage)) {
    redirectToCorrectPath({
      oldPrefix: oldPrefixForCategorySearchPage,
      redirect,
      path,
      query,
    });
  }
};
